export default () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3.83851C20 2.06109 18.5516 0.612701 16.7742 0.612701H3.22581C1.44839 0.612701 0 2.06109 0 3.83851V14.1611C0 15.9385 1.44839 17.3869 3.22581 17.3869H16.7742C18.5516 17.3869 20 15.9385 20 14.1611V3.83851ZM6.45161 15.4514H3.22581C2.5129 15.4514 1.93548 14.874 1.93548 14.1611V3.83851C1.93548 3.1256 2.5129 2.54819 3.22581 2.54819H6.45161V15.4514ZM18.0645 14.1611C18.0645 14.874 17.4871 15.4514 16.7742 15.4514H8.3871V2.54819H16.7742C17.4871 2.54819 18.0645 3.1256 18.0645 3.83851V14.1611Z"
      fill="currentColor"
    />
  </svg>
);
